import * as React from "react";
import { useState, useCallback } from "react";

import { useTranslation } from "react-i18next";
import DawaAutocomplete2 from "../libs/dawa-autocomplete2-react";
import { Button, Slider, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/da";
import useValidation from "../hooks/useValidation";
import axios from "axios";

const Home = ({ currentTab }) => {
	const { t } = useTranslation();
	const { validateName, validateEmail, validatePhone } = useValidation();

	const [validationErrors, setValidationErrors] = useState({
		"contact-name-first": "",
		"contact-name-last": "",
		"contact-name-email": "",
		"contact-phone": "",
	});

	const [formNameFirst, setFormNameFirst] = useState("");
	const handleNameFirstChange = useCallback(
		(value) => {
			const validationError = validateName(value);
			setValidationErrors((prevState) => {
				return {
					...prevState,
					"contact-name-first": validationError,
				};
			});
			setFormNameFirst(value);
		},
		[validateName]
	);

	const [formNameLast, setFormNameLast] = useState("");
	const handleNameLastChange = useCallback(
		(value) => {
			const validationError = validateName(value);
			setValidationErrors((prevState) => {
				return {
					...prevState,
					"contact-name-last": validationError,
				};
			});
			setFormNameLast(value);
		},
		[validateName]
	);

	const [formEmail, setFormEmail] = useState("");
	const handleEmailChange = useCallback(
		(value) => {
			const validationError = validateEmail(value);
			setValidationErrors((prevState) => {
				return {
					...prevState,
					"contact-name-email": validationError,
				};
			});
			setFormEmail(value);
		},
		[validateEmail]
	);

	const [formPhone, setFormPhone] = useState("");
	const handlePhoneChange = useCallback(
		(value) => {
			const validationError = validatePhone(value);
			setValidationErrors((prevState) => {
				return {
					...prevState,
					"contact-phone": validationError,
				};
			});
			setFormPhone(value);
		},
		[validatePhone]
	);

	const [formAddress, setFormAddress] = useState("");
	const handleAddressChange = useCallback((value) => {
		setFormAddress(value);
	}, []);

	const [formBrokers, setFormBrokers] = useState(3);
	const handleBrokersChange = useCallback((event, value) => {
		setFormBrokers(value);
	}, []);

	const [formSubmitted, setFormSubmitted] = useState(false);

	const [formDateTime, setFormDateTime] = React.useState([
		dayjs().add(4, "days").hour(14).minute(0),
		dayjs().add(4, "days").hour(16).minute(0),
		dayjs().add(4, "days").hour(18).minute(0),
		dayjs().add(4, "days").hour(20).minute(0),
	]);
	const daysOfWeek = React.useMemo(
		() => [
			"Søndag",
			"Mandag",
			"Tirsdag",
			"Onsdag",
			"Torsdag",
			"Fredag",
			"Lørdag",
		],
		[]
	);

	console.log(formAddress);

	const submitForm = useCallback(() => {
		let times = [];
		for (let n = 0; n < formBrokers; n++) {
			times.push(
				formDateTime[n].get("year") +
					"-" +
					(formDateTime[n].get("month") + 1) +
					"-" +
					formDateTime[n].get("date") +
					" " +
					formDateTime[n].get("hour").toString().padStart(2, "0") +
					":" +
					formDateTime[n].get("minute").toString().padStart(2, "0")
			);
		}

		let postData = {
			city: formAddress.address_components.postnrnavn,
			zip: formAddress.address_components.postnr,
			address: formAddress.address,
			address_components: formAddress.address_components,
			name_first: formNameFirst,
			name_last: formNameLast,
			email: formEmail,
			phone: formPhone,
			times: JSON.stringify(times),
		};

		axios
			.post(
				`https://busysunday.dk/wp-json/busysunday/v1/vurderinger/create`,
				postData
			)
			.then((output) => {
				setFormSubmitted(true);
				if (output.data.result) {
				}
			});
	}, [
		formAddress,
		formBrokers,
		formDateTime,
		formEmail,
		formNameFirst,
		formNameLast,
		formPhone,
	]);

	const handleFormDateTime = useCallback(
		(value, index) => {
			let dateTime = formDateTime;
			dateTime[index] = value;
			setFormDateTime(dateTime);
		},
		[formDateTime]
	);

	const addCasePrimaryAddress = useCallback(
		(address) => {
			let contactAddress = {
				lat: address.data.x,
				lng: address.data.y,
				radius: 0,
				address: address.tekst,
				address_components: address.data,
			};

			handleAddressChange(contactAddress);
		},
		[handleAddressChange]
	);

	const renderBrokers =
		formNameFirst.length > 0 &&
		formNameLast.length > 0 &&
		formEmail.length > 0 &&
		formPhone.length > 0 &&
		Object.entries(validationErrors).every(([_, value]) => value.length <= 0);

	return (
		<div className="w-full">
			<div className="w-full bg-gray-100 p-8 border border-solid border-gray-300 rounded">
				{formSubmitted && (
					<div>
						<h3 className="col-span-12 text-center">Tak for din henvendelse</h3>
						<p>
							Du har bedt om at få {formBrokers} ejendomsmæglere på besøg på
							adressen
						</p>
						<h4>{formAddress.address}</h4>
						{Array.from({ length: formBrokers }, (_, index) => (
							<div className="grid grid-cols-12 mb-4">
								<div className="col-span-4">Mægler {index + 1}</div>
								<div className="col-span-8">
									{daysOfWeek[formDateTime[index].get("day")]}
									{" d. "}
									{formDateTime[index].get("date")}/
									{formDateTime[index].get("month") + 1} kl.{" "}
									{formDateTime[index].get("hour").toString().padStart(2, "0")}:
									{formDateTime[index]
										.get("minute")
										.toString()
										.padStart(2, "0")}
								</div>
							</div>
						))}
						<h4>Hvad kan du forvente?</h4>
						<p>
							Du skal forvente at der bruges 1-2 timer på en vurdering, og at
							ejendomsmægler møder op velforberedt og klar til at gennemgå din
							bolig på ovenstående tider.
						</p>
						<h4>Ejendomsmægler vil</h4>
						<ul>
							<li>Grundigt gennemgå din bolig</li>
							<li>Fortælle dig om boligmarkedet i dit område</li>
							<li>
								Komme med info om netop din bolig, som bidrager til salget
							</li>
							<li>Samt fortælle hvordan boligen kan sælges bedst muligt</li>
						</ul>
						<p>
							Hver ejendomsmægler vil tage kontakt til dig inden hver vurdering.
						</p>
						<p>
							Skulle der være spørgsmål, så kan du kontakte BusySunday på tlf.
							26741448, eller på Info@BusySunday.dk
						</p>
					</div>
				)}
				{!formSubmitted && (
					<div className="mx-auto grid grid-cols-12 gap-4">
						<h3 className="col-span-12 text-center">Vælg først din adresse</h3>
						<div className="col-span-12 w-full max-w-xl mx-auto">
							<DawaAutocomplete2
								select={(caseselected) => {
									addCasePrimaryAddress(caseselected);
								}}
								placeholder={t("keyword.typeAddress")}
								classes={{
									root: "dawa-root col-span-12 border border-gray-200 w-full max-w-full",
									input: "dawa-input w-full px-2 py-4 ",
									ul: "ul",
									li: "li",
									selected: "selected",
								}}
							/>
						</div>
						{formAddress && (
							<>
								<h3 className="col-span-12 text-center">
									Udfyld dine kontaktinformationer
								</h3>
								<TextField
									className="col-span-12 lg:col-span-6"
									required
									id="contact-name-first"
									label={t("keyword.firstName")}
									value={formNameFirst}
									error={validationErrors["contact-name-first"].length > 0}
									helperText={
										validationErrors["contact-name-first"].length > 0 &&
										t(validationErrors["contact-name-first"])
									}
									onChange={(e) => {
										handleNameFirstChange(e.target.value);
									}}
								/>
								<TextField
									className="col-span-12 lg:col-span-6"
									required
									id="contact-name-last"
									label={t("keyword.lastName")}
									value={formNameLast}
									error={validationErrors["contact-name-last"].length > 0}
									helperText={
										validationErrors["contact-name-last"].length > 0 &&
										t(validationErrors["contact-name-last"])
									}
									onChange={(e) => {
										handleNameLastChange(e.target.value);
									}}
								/>
								<TextField
									className="col-span-12 lg:col-span-6"
									required
									id="contact-name-email"
									label={t("keyword.email")}
									value={formEmail}
									error={validationErrors["contact-name-email"].length > 0}
									helperText={
										validationErrors["contact-name-email"].length > 0 &&
										t(validationErrors["contact-name-email"])
									}
									onChange={(e) => {
										handleEmailChange(e.target.value);
									}}
								/>
								<TextField
									className="col-span-12 lg:col-span-6"
									required
									id="contact-phone"
									label={t("keyword.phone")}
									value={formPhone}
									error={validationErrors["contact-phone"].length > 0}
									helperText={
										validationErrors["contact-phone"].length > 0 &&
										t(validationErrors["contact-phone"])
									}
									onChange={(e) => {
										handlePhoneChange(e.target.value);
									}}
								/>
							</>
						)}
						{renderBrokers && (
							<>
								<h3 className="col-span-12 text-center">
									Jeg vil ha {formBrokers}{" "}
									{formBrokers === 1 ? "mægler" : "mæglere"} på besøg
								</h3>
								<div className="col-span-12 px-4">
									<Slider
										value={formBrokers}
										onChange={handleBrokersChange}
										step={1}
										min={2}
										max={4}
									/>
								</div>
								<LocalizationProvider
									dateAdapter={AdapterDayjs}
									adapterLocale="da"
								>
									{Array.from({ length: formBrokers }, (_, index) => (
										<DateTimePicker
											format=""
											key={index}
											className={
												formBrokers === 2
													? "w-full col-span-12 lg:col-span-6"
													: formBrokers === 3
													? "w-full col-span-12 lg:col-span-4"
													: "w-full col-span-12 md:col-span-6 lg:col-span-3"
											}
											renderInput={(props) => <TextField {...props} />}
											label="Vælg dato og tid"
											ampm={false}
											disablePast={true}
											value={formDateTime[index]}
											minDate={dayjs().add(4, "days")}
											maxDate={dayjs().add(60, "days")}
											shouldDisableClock={(timeValue, view) =>
												view === "hours" && (timeValue < 9 || timeValue > 20)
											}
											timeSteps={{ hours: 1, minutes: 15 }}
											onChange={(newValue) =>
												handleFormDateTime(newValue, index)
											}
										/>
									))}
								</LocalizationProvider>
							</>
						)}
						<div className="text-center col-span-12 text-2xl">
							<Button
								disabled={!renderBrokers}
								sx={{ fontSize: "22px" }}
								variant="contained"
								onClick={submitForm}
							>
								Bestil vurdering
							</Button>
						</div>{" "}
					</div>
				)}
			</div>
		</div>
	);
};

export default Home;
